import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { TitleService } from 'app/services/title.service';
import { PrincipalService } from 'app/services/auth/principal.service';
import { LoginServiceNg2 } from 'app/components/login/login.service';
import { AuthService } from 'app/services/auth/auth.service';

export function createRouterModule(states: Ng2StateDeclaration[]) {
  return UIRouterModule.forRoot({
    states: [...states],
    useHash: true,
    otherwise: { state: 'app.home' },
    config: (router) => {
      router.transitionService.onSuccess({}, (transition) => {
        const titleService: TitleService = transition.injector().get(TitleService);
        const resolvedTitle = transition.injector().get('$pageTitle');
        if (resolvedTitle) {
          titleService.setTitle(resolvedTitle);
          return;
        }
        titleService.setTitle(transition.to().data?.pageTitle ?? 'global.title');
      });

      router.transitionService.onBefore({}, async (transition) => {
        const requiredAuthorities = transition.to().data?.authorities;
        if (!requiredAuthorities) {
          return;
        }

        const principalService: PrincipalService = transition.injector().get(PrincipalService);
        if (!principalService.isAuthenticated()) {
          await principalService.identity(true);
        }
        if (principalService.hasAnyAuthority(requiredAuthorities)) {
          return;
        }
        if (principalService.isAuthenticated()) {
          return transition.router.stateService.target('app.home');
        }

        // anonymous user: let them sign in and continue into the state they asked for
        const authService: AuthService = transition.injector().get(AuthService);
        const loginService: LoginServiceNg2 = transition.injector().get(LoginServiceNg2);
        authService.resetPreviousState();
        const loggedIn = await loginService.open();
        if (loggedIn === true) {
          await principalService.identity(true);
          if (principalService.hasAnyAuthority(requiredAuthorities)) {
            return;
          }
        }

        // login was cancelled or did not grant access: stay put, or go home if there is nowhere to stay
        return transition.from().name ? false : transition.router.stateService.target('app.home');
      });
    },
  });
}
